module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/176.9c056fb7.png";